// React Basic and Bootstrap
import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import PageBreadcrumb from "../../../components/Shared/PageBreadcrumb";
import WhatWeDo from "../../../pages/Classic Application/WhatWeDo";
import work6 from "../../../assets/images/illustrator/inbox-cleanup.svg";
import sspbg from "../../../assets/images/terratraf/sspbg.jpg";
import client1 from "../../../assets/images/client/01.jpg";
import client2 from "../../../assets/images/client/02.jpg";
import client3 from "../../../assets/images/client/03.jpg";
import client4 from "../../../assets/images/client/04.jpg";

class PageWorkDetailSSP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathItems: [
        //id must required
        { id: 1, name: "Terratraf", link: "/" },
        { id: 2, name: "Services", link: "/" },
        { id: 3, name: "SSP", link: "/services/ssp" },
      ],
      comments: [
        {
          id: 1,
          image: client1,
          name: "Lorenzo Peterson",
          date: "15th August, 2019",
          time: "01:25 pm",
          desc:
            "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour",
        },
        {
          id: 2,
          image: client2,
          name: "Tammy Camacho",
          date: "16th August, 2019",
          time: "02:05 pm",
          desc:
            "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour",
        },
        {
          id: 3,
          image: client3,
          name: "Tammy Camacho",
          date: "17th August, 2019",
          time: "04:03 pm",
          desc:
            "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour",
          replies: [
            {
              id: 1,
              image: client4,
              name: "Calvin Camacho",
              date: "18th August, 2019",
              time: "05:55 pm",
              desc:
                "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour",
            },
          ],
        },
      ],
      Contactvisible: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ Contactvisible: true });
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }
  // Make sure to remove the DOM listener when the component is unmounted.
  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (top > 80) {
      document.getElementById("topnav").classList.add("nav-sticky");
    } else {
      document.getElementById("topnav").classList.remove("nav-sticky");
    }
  };

  render() {
    return (
      <React.Fragment>
        {/* breadcrumb */}
        <PageBreadcrumb pathItems={this.state.pathItems} headBg={sspbg}>
          <h4 className="title" style={{color: '#ffffff'}}> SSP </h4>
          <ul className="list-unstyled mt-4">
            <li className="list-inline-item h6 user me-2" style={{color: '#ffffff'}}>
              {" "}
              запущен в 2017 году
            </li>
            {/*<li className="list-inline-item h6 date text-muted ms-1">*/}
            {/*  {" "}*/}
            {/*  <span className="text-dark">Date :</span> 23th Sep, 2019*/}
            {/*</li>*/}
          </ul>
        </PageBreadcrumb>

        <div className="position-relative">
          <div className="shape overflow-hidden text-white">
            <svg
              viewBox="0 0 2880 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>

        <section className="section">
          <Container>
            <Row className="justify-content-center">

              <Col md={12} className="">
                <div className="p-4">
                  <h2 className="mb-0 product__mainText">
                    SSP (Supply Side platform)  - технологическая платформа, с помощью которой рекламные сети или отдельные сайты могут продать свои рекламные площади.
                  </h2>
                </div>



                <div className="bg-light rounded p-4 mt-4 pt-2">
                  {/*<p className="text-muted fst-italic mb-0">*/}
                  {/*  С появлением рекламных бирж и распространением RTB SSP, как оптимизаторы доходов, превратились в независимые службы, которые обеспечивают аукционные продажи, основанные на таргетинге.*/}
                  {/*</p>*/}
                  <h6 className="card-title mt-4">
                    Административная панель SSP содержит разделы:
                  </h6>
                  <ul className="list-unstyled feature-list text-muted mt-1">
                    <li className="mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Площадки
                    </li>
                    <li className="mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Блоки
                    </li>
                    <li className="mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      Статистика
                    </li>

                  </ul>
                </div>
                <WhatWeDo/>
                <Row className="align-items-center">
                  <Col md={6} className="mt-4 pt-2">
                    <Card className="work-details rounded bg-light border-0">
                      <CardBody>
                        <h5 className="card-title border-bottom pb-3 mb-3">
                          SSP Информация о проекте :
                        </h5>
                        <dl className="row mb-0">
                          <dt className="col-md-4 col-5">Название :</dt>
                          <dd className="col-md-8 col-7 text-muted">
                            SSP
                          </dd>

                          <dt className="col-md-4 col-5">Категория:</dt>
                          <dd className="col-md-8 col-7 text-muted">
                            Supply-Side Платформа
                          </dd>

                          <dt className="col-md-4 col-5">Дата :</dt>
                          <dd className="col-md-8 col-7 text-muted">
                            2017
                          </dd>

                          <dt className="col-md-4 col-5">Сайт:</dt>
                          <dd className="col-md-8 col-7 text-muted">
                            <a href="https://ssp.mediasniper.ru" className="text-primary" target="_blank" rel="noreferrer">https://ssp.mediasniper.ru<i className="uil uil-angle-right-b"></i></a>
                          </dd>
                        </dl>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md={6} className="mt-4 pt-2">
                    <img src={work6} className="img-fluid rounded" alt="" />
                  </Col>
                </Row>

              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
export default PageWorkDetailSSP;
